// extracted by mini-css-extract-plugin
export default {"modalStyle":"CreateCollection_modalStyle__HJjzX","buttonBox":"CreateCollection_buttonBox__d4Pfx","buttonStyles":"CreateCollection_buttonStyles__WV8K+"};